import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg24AdminsettingG = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M11.808 3.623a6.4 6.4 0 0 1 6.85-1.077.6.6 0 0 1 .177.98l-3.083 2.996.384 1.816 1.807.435 3.08-2.997a.6.6 0 0 1 .931.117l.043.086c.98 2.4.43 5.176-1.456 7.011a6.38 6.38 0 0 1-6.184 1.56l-.133-.04-6.98 6.802a3.09 3.09 0 0 1-4.228.076l-.14-.136a3.09 3.09 0 0 1 .059-4.369l6.981-6.803-.036-.133a6.38 6.38 0 0 1 1.543-5.95l.186-.189zm5.456-.284a5.19 5.19 0 0 0-4.818 1.33C11 6.074 10.524 8.17 11.164 10.063a.6.6 0 0 1-.15.622l-7.242 7.057a1.89 1.89 0 0 0 2.634 2.709l7.242-7.056a.6.6 0 0 1 .626-.133c1.876.692 3.984.274 5.43-1.133a5.19 5.19 0 0 0 1.463-4.779l-.009-.033-2.616 2.546a.6.6 0 0 1-.458.169l-.1-.015-2.496-.601a.6.6 0 0 1-.446-.46l-.531-2.51a.6.6 0 0 1 .168-.554l2.618-2.546zm-11.17 14.77a.595.595 0 1 1 0-.001z"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg24AdminsettingG$1 = Svg24AdminsettingG;

export { Svg24AdminsettingG$1 as default };
